module.exports = __webpack_public_path__ + "static/hero-bg-min-c40cef42c94e48224d11b659d776777b.png";